import "./searchbar.css";
import React from 'react';
import TextField from "@mui/material/TextField";
import userIcon from "../../images/userIcon.png";
import { styled } from '@mui/material/styles';
import ArrowDropDown from "@mui/icons-material/ArrowDropDown";
import { onSignOut } from '../../common/Utils';

// import LogoutIcon from '@mui/icons-material/Logout';
import {
  MDBNavbarItem,
  MDBDropdown,
  MDBDropdownToggle,
  MDBDropdownMenu,
  MDBDropdownItem,
} from 'mdb-react-ui-kit';

const CustomTextField = styled(TextField)({
  backgroundColor: '#EAEAEA',
  width: 300,
  height: 50,
  padding: 3,
  borderRadius: 50,
  borderColor: '#EAEAEA'
});

export default function Search({ roles }) {
  return (
    <div className='search-container'>
      {/*<CustomTextField id="standard-basic" variant="standard" label="Search" type="search" />*/}
      <img src={userIcon} alt='' className='user-image' />
      {/* <div class="tooltip">Welcome {roles}
        <ArrowDropDown style={{ fontSize: 20 }} />
        <span class="tooltiptext"><button className="signout-btn" onClick={() => onSignOut()}>Sign Out</button></span>
      </div> */}
      <MDBNavbarItem>
        <MDBDropdown>
          <MDBDropdownToggle tag='a' className='nav-link navDropDownHome' role='button'>
            Welcome {roles}
          </MDBDropdownToggle>
          <MDBDropdownMenu>
            <MDBDropdownItem><button className="signout-btn" onClick={() => onSignOut()}>Sign Out</button></MDBDropdownItem>
          </MDBDropdownMenu>
        </MDBDropdown>
      </MDBNavbarItem>
    </div>
  );
}